import React from "react";
import { withProcedureWraper } from "../..";
import { Box, Table, UserManual } from "../../../../components";
import { AiOutlineRadarChart } from "react-icons/ai";
import CreateRequestButton from "../../components/CreateRequestButton";
import { useMTPColumns } from "./hooks";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";
import { useMTPRequests } from "./hooks/use-MTP-requests";

const MonthlyTrainingPlan = withProcedureWraper(() => {
  const history = useHistory();

  const { columns } = useMTPColumns();
  const { isLoading, requests = [], myRequests } = useMTPRequests();

  return (
    <div className="pd15">
      <UserManual
        title="Kế hoạch đào tạo tháng"
        icon={<AiOutlineRadarChart size={26} />}
      />
      <Box
        title="Yêu cầu của tôi"
        titleRight={
          <CreateRequestButton
            onClick={() =>
              history.push(Routes.createMonthlyTrainingPlanPage.path)
            }
          />
        }
      >
        <Table
          loading={isLoading}
          rowKey="id"
          columns={columns}
          dataSource={myRequests}
          onRow={(record) => ({
            onClick: () =>
              history.push(
                `${Routes.monthlyTrainingPlanPage.path}/${record.id}`
              ),
            style: { cursor: "pointer" },
          })}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          loading={isLoading}
          rowKey="id"
          columns={columns}
          dataSource={requests}
          onRow={(record) => ({
            onClick: () =>
              history.push(
                `${Routes.monthlyTrainingPlanPage.path}/${record.id}`
              ),
            style: { cursor: "pointer" },
          })}
        />
      </Box>
    </div>
  );
});

export default MonthlyTrainingPlan;
